module.exports = __webpack_public_path__ + "static/media/umbrella.beb058d7.svg";